
//const XMLParser = require('react-xml-parser');
import TimeUtils from "../helper/TimeUtils";
import {parse} from "@fortawesome/fontawesome-svg-core";
import StringUtils from "../helper/StringUtils";

class DragObj {
    constructor(dataObj) {
                this.In = dataObj.In,
                this.Out = dataObj.Out,
                this.start = dataObj.start,
                this.end = dataObj.end,
                this.ShotChange = dataObj.ShotChange,
                this.Duration = dataObj.Duration,
                this.Memo = dataObj.Memo,
                this.Source = dataObj.Source,
                this.SubtitleCaption = dataObj.SubtitleCaption,
                this.Length = dataObj.Length,
                this.Position = dataObj.Position,

            this.dataIndex = dataObj.dataIndex,
            this.frontDistance = dataObj.frontDistance,
            this.index = dataObj.index,
            this.maxRight = dataObj.maxRight,
            this.maxLeft = dataObj.maxLeft,
            this.x = dataObj.x,
            this.width = dataObj.width
    }
    init(){
            this.In = "";
            this.Out = "";
            this.start = 0.0;
            this.end = 0.0;
            this.ShotChange = "";
            this.Duration = "",
            this.Memo = "";
            this.Source = "";
            this.SubtitleCaption = "";
            this.Length = 0.0;
            this.Position = 0.0;

        this.dataIndex = 0;
        this.frontDistance = 0;
        this.index = 0;
        this.maxRight = 0;
        this.x = 0;
        this.width = 0;
    }
}

export default DragObj;



// WEBPACK FOOTER //
// ./src/class/DragObj.js